/**
 * @generated SignedSource<<04bd70f00fc7e206d1133aaf59a1ebf5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type JobRunsListContainerRefetchQuery$variables = {
  id: any;
};
export type JobRunsListContainerRefetchQuery$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"JobRunsListContainer_job">;
  } | null | undefined;
};
export type JobRunsListContainerRefetchQuery = {
  response: JobRunsListContainerRefetchQuery$data;
  variables: JobRunsListContainerRefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "JobRunsListContainerRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "JobRunsListContainer_job"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "JobRunsListContainerRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "kind": "TypeDiscriminator",
            "abstractKey": "__isNode"
          },
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "schedule",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "inputJson",
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "limit",
                    "value": 20
                  },
                  {
                    "kind": "Literal",
                    "name": "sortBy",
                    "value": "started_at"
                  },
                  {
                    "kind": "Literal",
                    "name": "sortOrder",
                    "value": "desc"
                  }
                ],
                "concreteType": "GraphQLJobRunConnection",
                "kind": "LinkedField",
                "name": "jobRuns",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "GraphQLJobRunEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "GraphQLJobRun",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "status",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "createdAt",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "startedAt",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "completedAt",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "updatedAt",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "jobRuns(limit:20,sortBy:\"started_at\",sortOrder:\"desc\")"
              }
            ],
            "type": "GraphQLJob",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f572cb36d3457d6c753940d67458e585",
    "id": null,
    "metadata": {},
    "name": "JobRunsListContainerRefetchQuery",
    "operationKind": "query",
    "text": "query JobRunsListContainerRefetchQuery(\n  $id: GlobalID!\n) {\n  node(id: $id) {\n    __typename\n    ...JobRunsListContainer_job\n    __isNode: __typename\n    id\n  }\n}\n\nfragment DigestJobRunList_job on GraphQLJob {\n  id\n  name\n  schedule\n  inputJson\n  jobRuns(limit: 20, sortBy: \"started_at\", sortOrder: \"desc\") {\n    edges {\n      node {\n        id\n        status\n        createdAt\n        startedAt\n        completedAt\n        updatedAt\n      }\n    }\n  }\n}\n\nfragment JobRunsListContainer_job on GraphQLJob {\n  ...DigestJobRunList_job\n  id\n  name\n  jobRuns(limit: 20, sortBy: \"started_at\", sortOrder: \"desc\") {\n    edges {\n      node {\n        id\n        status\n        createdAt\n        startedAt\n        completedAt\n        updatedAt\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c35251e65e3fddc78317d69a136f3043";

export default node;
